import { useState } from 'react'
import { IconButton } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ArrowIcon, RejectCircleIcon } from 'src/assets/icons'
import { DeleteConfirmModal } from './delete-confirm-modal'
import { useRemoveAccount, useAccount } from 'src/hooks'
import { EAccountRoles } from 'src/types'
import { AppEvents } from 'src/constants'

import { useStyles } from '../styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

export const CloseAccountMobile = () => {
  const [t] = useTranslation()
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const { mutateAsync: removeAccount } = useRemoveAccount()
  const { data: account } = useAccount()

  const handleOpen = () => {
    if (!account?.currentRoles.includes(EAccountRoles.owner)) {
      const detail = {
        message: t('close-account-owner-warning.v'),
      }
      const event = new CustomEvent(AppEvents.HTTP_ERROR, { detail })
      return document.dispatchEvent(event)
    }

    setOpen(true)
  }
  const handleClose = () => setOpen(false)

  const handleDelete = async () => {
    const resp = await removeAccount()
    if (!resp) return

    handleClose()
  }

  return (
    <>
      <div className={classes.settingsItemWrapper}>
        <div className={classes.settingsLeftWrapper}>
          <div className={`${classes.settingsIconWrapper} ${classes.settingsIconWrapperLight}`}>
            <RejectCircleIcon className={classes.lightIcon} />
          </div>
          <h4 className={`${classes.settingsTitle} ${classes.settingsTitleDark}`}>
            <HelperWrapper t="account-support-action-section" />
          </h4>
        </div>
        <div>
          <IconButton onClick={handleOpen}>
            <ArrowIcon className={`${classes.dropdownIcon} ${classes.greyIcon}`} />
          </IconButton>
        </div>
      </div>
      {account && (
        <DeleteConfirmModal
          account={account}
          handleClose={handleClose}
          handleDelete={handleDelete}
          open={open}
        />
      )}
    </>
  )
}
